import { Component, OnInit, ViewChild } from '@angular/core';
import { GeneralExerciseComponent } from '../../General/g-exercise.component';
import { ActivatedRoute } from '@angular/router';
import { TopicService } from '../topic.service';
import { MessageService } from '../../shared/message.service';
import { CryptoService } from '../crypto.service';
import { CaesarComponent } from '../caesar/caesar.component';
import { InputFieldComponent } from '../input-field/input-field.component';
import { PolybiusComponent } from '../polybius/polybius.component';
import { CryptoView } from '../crypto-view';
import { SkytaleComponent } from '../skytale/skytale.component';
import { MonoalphabeticComponent } from '../monoalphabetic/monoalphabetic.component';
import { VignereComponent } from '../vignere/vignere.component';
import { PigpenComponent } from '../pigpen/pigpen.component';
import { AtbashComponent } from '../atbash/atbash.component';
import { MorseComponent } from '../morse/morse.component';

@Component({
  selector: 'app-encode-text',
  templateUrl: './encode-text.component.html',
  styleUrls: ['../topic-style.css', './encode-text.component.css']
})
export class EncodeTextComponent extends GeneralExerciseComponent {

  @ViewChild('caesar', {static: true})
  private caesar: CaesarComponent;
  
  @ViewChild('polybius', {static: true})
  private polybius: PolybiusComponent;

  @ViewChild('skytale', {static: true})
  private skytale: SkytaleComponent;

  
  @ViewChild('monoalphabetic', {static: true})
  private monoalphabetic: MonoalphabeticComponent;
  
  @ViewChild('vignere', {static: true})
  private vignere: VignereComponent;
  
  @ViewChild('pigpen', {static: true})
  private pigpen: PigpenComponent;

  @ViewChild('atbash', {static: true})
  private atbash: AtbashComponent;

  @ViewChild('morse', {static: true})
  private morse: MorseComponent;
  
  private view: CryptoView;


  @ViewChild('inputField', {static: true})
  private inputField: InputFieldComponent;

  plainText: string;
  cipherText: string;
  method: string;
  keyP: any;
  modus: string;

  dPlainText: string[];

  caretPos: number = 0;
  positionLetter: string;

  errors: number[] = [];

  constructor(activatedRoute: ActivatedRoute, topicService: TopicService, messageService: MessageService, protected cryptoService: CryptoService) {
    super(activatedRoute, topicService, messageService);
    this.printable=true;
    this.type = "encode";
  }

  checkSolution() {
    let solution = this.cryptoService.encode(this.method, this.keyP, this.plainText);
    this.cipherText = this.inputField.getText();

    this.errors = solution.split("").map((v, i) => [v, this.cipherText.charAt(i), i]).filter(v => v[0] != v[1]).map(v => +v[2]);
    if(this.method == "polybius"){
      this.errors = this.errors.map((v ,i) => Math.floor((v - this.cipherText.substring(0,v).replace(/[^ ]/gi, "").length)/2 + this.cipherText.substring(0,v).replace(/[^ ]/gi, "").length)) ;
    }
    if(this.method == "skytale"){
      this.errors = this.errors.map((v,i)=>Math.floor(v% this.keyP) *(Math.ceil(this.plainText.length / this.keyP))  + Math.floor(v / this.keyP));
    }
    if(this.method == "morse"){
      this.errors = this.errors.map(v => this.cipherText.substring(0, v).split("|").length - 1);
    }
    if (this.errors.length > 0) {
      this.messageService.addAlertWithTimeout(this.get("notCorrectlyEncoded"), "danger", 10000);
    } else {
      this.messageService.addAlertWithTimeout(this.get("correctlyEncoded"), "success", 10000);
      this.solved = true;
      this.state.solved = true;
      this.saveState();
    }
  }


  computeState() {
    this.cipherText = this.inputField.getText();
    this.state.typespecific.cipherText = this.cipherText;
    this.state.typespecific.mapping = this.view.getMapping();
  }

  setTypeSpecificsFromState() {
    if (this.state.typespecific) {
      if (this.state.typespecific.cipherText) {
        this.cipherText = this.state.typespecific.cipherText;
      }
      if (this.state.typespecific.mapping) {
        this.view.setmapping(this.state.typespecific.mapping);
      }
    }
  }

  setTypeSpecificsFromConfiguration() {
    this.plainText = this.configuration.typespecifics.text;
    this.dPlainText = this.plainText.split("");
    this.method = this.configuration.typespecifics.method;
    this.keyP = this.configuration.typespecifics.key;

    this.cipherText = this.cryptoService.encode(this.method, this.keyP, this.plainText).replace(/[A-z0-9.-]/gi, "#");
    this.modus = this.configuration.typespecifics.modus;
    switch(this.method){
      case "caesar": this.view = this.caesar; break;
      case "polybius": this.view = this.polybius; break;
      case "skytale": this.view = this.skytale; break;
      case "monoalphabetic": this.view = this.monoalphabetic; break;
      case "vignere": this.view = this.vignere; break;
      case "pigpen": this.view = this.pigpen; break;
      case "atbash": this.view = this.atbash; break;
      case "morse": this.view = this.morse; break;
    }
    console.log(this.view);
    this.caretPos = 0;
    this.onEmit(this.caretPos);
    if (this.view) {
      this.view.resetmapping();
    }
  }

  evaluate(): number[] {
    let solution = this.cryptoService.encode(this.method, this.keyP, this.plainText);
    this.cipherText = this.inputField.getText();
    let errors = solution.split("").map((v, i) => [v, this.cipherText.charAt(i), i]).filter(v => v[0] != v[1]).map(v => +v[2]);
    let result = [Math.max((this.plainText.length - errors.length) / 20, 0), this.plainText.length / 20];
    if (this.modus == 'highlight') {
      result = result.map(v => v / 2);
    }
    if(this.method == "vignere"){
      result = result.map(v => v * 1.5);
    }
    return result;
  }

  /** when the cipher text changes, compute the highlighted letter */
  onEmit(event) {
    this.caretPos = event;
    this.positionLetter = this.plainText.charAt(this.caretPos);
    if(this.method == "skytale"){
      this.positionLetter = this.caretPos.toString();
      this.caretPos = Math.floor(event% this.keyP) *(Math.ceil(this.plainText.length / this.keyP))  + Math.floor(event / this.keyP);
      while(this.plainText.charAt(this.caretPos) === " "){
        this.caretPos--;
      }
    }

    if(this.method == "vignere"){
      this.positionLetter = this.caretPos.toString();
    }
  }

  /** returns the correct method description */
  getMethodDescription(){
    switch(this.method){
      case "caesar": return this.get("useCaesar");
      case "polybius": return this.get("usePolybius");
      case "skytale": return this.get("useSkytale");
      case "monoalphabetic": return this.get("useMonoalphabetic");
      case "vignere": return this.get("useMask");
      case "pigpen": return this.get("usePigpen");
      case "atbash": return this.get("useAtbash");
      case "morse": return this.get("useMorse");
    }
    
  }

  preprint(){
    if (this.modus == "highlight") {
      this.modus = "normal";
    }
  }

  postprint(){
    this.modus = this.configuration.typespecifics.modus;
  }


}
